import styled from 'styled-components'
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { useDispatch } from 'react-redux'
import { useState,useEffect } from 'react';
import api from '../axios.js'



const Container=styled.div`


  `;


export default function Buttons(props){
	let { estado,alterEstado,empty,action,estadoBase,dataSave,url,reloadAction,idDelete,selected } = props;	
	let [loading,setLoading]=useState(false);
	
	let dispatch=useDispatch();



	let createGame=()=>{
		dispatch(alterEstado(1));
		dispatch(action(estadoBase));
	};

	let saveGame=async()=>{
		
		if(!Object.values(dataSave).some(val=>val==="")){
		
			if(window.confirm(`desea grabar estos datos?`)){		
				switch(estado){
					case 1:						
						setLoading(true);
							try{
								await api.post(url,dataSave);
								alert("datos grabados");
								dispatch(alterEstado(0));
								dispatch(action(estadoBase));

						}catch(err){
							alert(`error al grabar: ${err.message}`)};
							dispatch(reloadAction);
							setLoading(false);
						break
					case 2:
						window.confirm(`desea grabar estos datos?`);
						setLoading(true);
						try{
								await api.patch(url,dataSave);
								alert("datos grabados");
								dispatch(alterEstado(0));
								dispatch(action(estadoBase));
						}catch(err){alert(`error al grabar: ${err.message}`)};
						setLoading(false);
						break
					default:
						console.log("")//					
					break
				}
			};
			
		}else{alert('verificar datos')}
			
	}

	let modifyGame=()=>{
		dispatch(alterEstado(2));

	}

	let cancel=()=>{
		dispatch(alterEstado(0));
	}

	

	let deleteGame=async()=>{
		if(window.confirm("desea eliminar este registro")){
				dispatch(alterEstado(4));
			try{
				await api.delete(`${url}/?id=${idDelete}`);
				alert(`registro fue eliminado `);
				dispatch(alterEstado(0));
				dispatch(selected);
			}catch(err){console.log(err);alert(`error al guardar ${err.response.data}`)}					
		}
		dispatch(alterEstado(0));
	}

	useEffect(()=>{},[dispatch])
	return(
		<Container>
			<ButtonGroup variant="outlined" aria-label="Loading button group">
      			<Button onClick={createGame} variant="contained" sise="small" disabled={estado!==0? true:false} >crear</Button>
      			<Button onClick={modifyGame} variant="contained" sise="small" disabled={empty||estado!==0? true:false} >modificar</Button>
      			<Button onClick={deleteGame} variant="contained" sise="small" disabled={empty||estado!==0? true:false} >eliminar</Button>  
      			<Button onClick={cancel} variant="contained" sise="small" disabled={estado!==0? false:true} >cancelar</Button> 
      			<LoadingButton onClick={saveGame} variant="contained" sise="small" disabled={estado!==0? false:true} loading={loading} loadingPosition="start" startIcon={<SaveIcon />}>
        			grabar
      			</LoadingButton>
   		</ButtonGroup>
			
		</Container>)
}